import { getCatalog } from '../../../api/movies/index';
import { store } from '../../../utils/globalData';
import { checkImage } from '../../../utils/helpers';
import VODComponent from '../../Home/components/VODComponent';
import VODRow from '../../Home/components/VODRow';

const mapMovie = (movies, id) => {
  const movie = Object.values(movies).find((movie) => movie.id === id);

  if (!movie) {
    console.error(`Movie with id ${id} not found`);
    return null; // ili vratite neki podrazumevani objekat
  }
  return {
    collision: true,
    type: VODComponent,
    src: checkImage(movie?.alternative_covers, movie?.['cover_art.expiring_url'] ?? ''), // Koristimo ?. za zaštitu i ?? za podrazumevanu vrednost
    isLocked: movie.tvod ?? false, // Koristimo podrazumevanu vrednost ako je tvod undefined
    isProtected: movie?.locked ?? false,
    w: 204,
    h: 290,
    data: {
      originalImage: movie?.['cover_art.expiring_url'] ?? 'default_image.png', // Podrazumevana slika ako je undefined
      kind: movie?.kind ?? 'Unknown', // Podrazumevana vrednost ako je undefined
      id: movie?.id ?? 'Unknown', // Podrazumevana vrednost ako je undefined
      title: movie?.name ?? 'No Title', // Podrazumevani naslov ako je undefined
      description: movie?.description ?? 'No Description Available', // Podrazumevani opis ako je undefined
      cover: movie?.['screenshot.expiring_url'] ?? 'default_cover.png', // Podrazumevani cover ako je undefined
      category: movie?.tags ?? [], // Podrazumevana vrednost ako je tags undefined
      duration: movie?.duration ?? '0', // Podrazumevana vrednost ako je duration undefined
      rating: movie?.imdb?.rating === null ? '−' : movie?.imdb?.rating?.avg ?? '−', // Provera ako je rating null ili undefined
      votes: movie?.imdb?.rating === null ? '−' : movie?.imdb?.rating?.num_votes ?? '−', // Provera ako je num_votes null ili undefined
      contentRating: movie?.content_rating ?? 'Not Rated', // Podrazumevana vrednost ako je content_rating undefined
    },
  };
};

const mapSeries = (series, id) => {
  const serie = Object.values(series).find((serie) => serie.id === id);

  if (!serie) {
    console.error(`Series with id ${id} not found`);
    return null; // ili vratite neki podrazumevani objekat
  }
  return {
    collision: true,
    type: VODComponent,
    src: checkImage(serie?.alternative_covers, serie?.['cover_art.expiring_url'] ?? ''), // Koristimo ?. za zaštitu i ?? za podrazumevanu vrednost
    isProtected: false,
    w: 204,
    h: 290,
    data: {
      originalImage: serie?.['cover_art.expiring_url'] ?? 'default_image.png', // Podrazumevana slika ako je undefined
      kind: serie?.kind ?? 'Unknown', // Podrazumevana vrednost ako je undefined
      id: serie?.id ?? 'Unknown', // Podrazumevana vrednost ako je undefined
      title: serie?.name ?? 'No Title', // Podrazumevani naslov ako je undefined
      description: serie?.description ?? 'No Description Available', // Podrazumevani opis ako je undefined
      cover: serie?.['screenshot.expiring_url'] ?? 'default_cover.png', // Podrazumevani cover ako je undefined
      category: serie?.tags ?? [], // Podrazumevana vrednost ako je tags undefined
      duration: serie?.duration ?? '0', // Podrazumevana vrednost ako je duration undefined
      rating: serie?.imdb?.rating === null ? '−' : serie?.imdb?.rating?.avg ?? '−', // Provera ako je rating null ili undefined
      votes: serie?.imdb?.rating === null ? '−' : serie?.imdb?.rating?.num_votes ?? '−', // Provera ako je num_votes null ili undefined
      contentRating: serie?.content_rating ?? 'Not Rated', // Podrazumevana vrednost ako je content_rating undefined
    },
  };
};

const mapCollections = (collections, id) => {
  const collection = Object.values(collections).find((collection) => collection.id === id);
  return {
    type: VODComponent,
    src: collection['cover_art.expiring_url'],
    isProtected: false,
    w: 290,
    h: 204,
    data: {
      kind: 'collection', // TO REMOVE
      id: collection.id,
      title: collection.name ?? '',
      description: '', // TO REMOVE
      cover: collection['screenshot.expiring_url'],
      category: '', // TO REMOVE
      duration: '00:00', // TO REMOVE
      rating: 1, // TO REMOVE
      votes: 0, // TO REMOVE
      contentRating: 0, // TO REMOVE
    },
  };
};

export default async function (page) {
  let data = store.getData();

  if (!data) {
    console.log('Nema u store, preuzimam podatke...');
    const catalogData = await getCatalog();
    data = catalogData.data;
    store.setData(data);
    store.setMyListFlag(true);
  } else {
    console.log('Podaci su već u store');
  }
  const rows = data.data.root_index;
  const categories = data.index;
  let moviesArray = [];
  let seriesArray = [];
  rows.forEach((row) => {
    const category = Object.values(categories[row.kind]).find(
      (category) => category.id === row.id && category.id === 1 && category.kind == 'dynamic_series'
    );
    if (category) {
      const isCollectionRow = !category?.items?.some((item) => item.kind !== 'collection');
      const title = category?.name ?? '';
      const items = category?.items
        .map((item, itemIndex) => {
          switch (item.kind) {
            case 'movie':
              const movieItem = mapMovie(categories.movies, item.id);
              if (movieItem) {
                // Add index to each movie item
                movieItem.index = itemIndex;
                movieItem.rowIndex = moviesArray.length ? 0 : 1; // Add rowIndex to each movie item
                moviesArray.push(movieItem);
              }
              return movieItem;
            case 'subseries':
              const subseriesItem = mapSeries(categories.subseries, item.id);
              if (subseriesItem) {
                // Add index to each series item
                subseriesItem.index = itemIndex;
                subseriesItem.rowIndex = moviesArray.length ? 1 : 0; // Add rowIndex to each series item
                seriesArray.push(subseriesItem);
              }
              return null;
            case 'collection':
              const collectionItem = mapCollections(categories.collections, item.id);
              return collectionItem;
            default:
              return null;
          }
        })
        .filter((pageItem) => Boolean(pageItem));

      if (!isCollectionRow) {
        if (category.items.find((item) => item?.kind === 'movie')) {
          moviesArray = items;
        } else if (category.items.find((item) => item?.kind === 'subserie')) {
          seriesArray = items;
        }
      }
    }
  });

  // Determine the row index for movies and series
  let movieRowIndex = moviesArray.length ? 0 : -1;
  let seriesRowIndex = moviesArray.length ? 1 : 0;

  // Movies row (if available)
  const moviesRow = {
    type: VODRow,
    scrollIndex: 2,
    collision: true,
    title: 'New Movies',
    h: 400,
    rowIndex: movieRowIndex, // Add row index for movies
    items: moviesArray.map((movie, index) => ({
      ...movie,
      index,
      rowIndex: movieRowIndex, // Include rowIndex inside the data for each movie
    })),
    style: { itemSpacing: 40 },
  };

  // Series row (if available)
  const seriesRow = {
    type: VODRow,
    scrollIndex: 2,
    collision: true,
    title: 'New Series',
    h: 400,
    rowIndex: seriesRowIndex, // Add row index for series
    items: seriesArray.map((serie, index) => ({
      ...serie,
      index,
      rowIndex: seriesRowIndex, // Include rowIndex inside the data for each series
    })),
    style: { itemSpacing: 40 },
  };

  // Set the rows in the page
  page._Column.items = [
    ...(moviesArray.length ? [moviesRow] : []),
    ...(seriesArray.length ? [seriesRow] : []),
  ];

  // Store the data in the page object
  page.data = { seriesArray, moviesArray };
}
